import { GenericObject } from "@vahak/core/dist/custom-types/generic-object";

import { LoadQuoteValues } from "../load-quote";
import { IEventTrackerProp } from "../../../types/events";

export enum COMPACT_LOAD_POSTING_STEPS {
    ROUTE_DETAILS = "routeDetails",
    LOAD_DETAILS = "loadDetails",
    FREIGHT_QUOTE = "freightQuote",
    LOGIN = "login",
    SUCCESS = "success",
    ERROR = "error"
}

export interface CompactLoadPostingState extends LoadQuoteValues {
    lorryBodyType?: number | null;
    lorrySize?: number;
    lorryTyres?: number;
    sizeText?: string;
    lorrySizeNoPreference?: boolean;
    loadingTimestamp?: number;
    expectedAmount?: number;
    advancePaymentPercentage?: number;
    minExpectedPrice?: number;
    recommendedPriceMin?: number;
    recommendedPriceMax?: number;
    priceRecommendationReady?: boolean;
    loadId?: number;
}

/** Initial compact session values — may include full load details for repost prefill. */
export type CompactLoadPostingInitialValues = CompactLoadPostingState;

export interface OpenCompactPostingOptions {
    /** Extra analytics payload merged over the provider default `eventData` for this session. */
    eventData?: GenericObject;
    /** When true, the post API is called with `is_reposted`. */
    isRepost?: boolean;
    /** Called after a successful post / repost before the success screen is shown. */
    onSuccess?: () => void;
}

export interface CompactLoadPostingModalProps extends IEventTrackerProp {
    isOpen: boolean;
    initialValues?: CompactLoadPostingInitialValues;
    isRepost?: boolean;
    onSuccess?: () => void;
    onClose: () => void;
}

export function getDefaultLoadingTimestamp(): number {
    const date = new Date();
    date.setHours(date.getHours() + 4, 0, 0, 0);
    return Math.floor(date.getTime() / 1000);
}
